import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { AppState } from '../reducers/rootReducer';

const _companyState = (state: AppState) => state.Company;

export const selectCompanySettings = createDraftSafeSelector(
  _companyState,
  payload => payload.companySettings,
);
